import React from "react";
import CommonButtons from "src/shared/components/CommonButtons";
interface ImportButtonProps {
  inputRef: React.RefObject<HTMLInputElement>;
  handleImport: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ImportButton: React.FC<ImportButtonProps> = ({ inputRef, handleImport }) => (
  <div className="import-area cursor-pointer">
    <CommonButtons label="IMPORT" className="w-40" onClick={() => inputRef.current?.click()} />
    <input
      ref={inputRef}
      type="file"
      style={{ display: "none" }}
      onChange={handleImport}
    />
  </div>
);

export default ImportButton;
